const ICONS = {
  success: '✅',
  error: '❌',
  info: 'ℹ️',
};

export function Toasts({ toasts }) {
  return (
    <div className="toast-stack" aria-live="polite">
      {toasts.map((toast) => (
        <div key={toast.id} className={`toast toast-${toast.type || 'info'}`}>
          {ICONS[toast.type] || ICONS.info} {toast.message}
        </div>
      ))}
    </div>
  );
}
